import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { instance } from "../authReduser/autentification.redusers";
import { API_URL } from "../../../srevices/api";

import Notiflix from "notiflix";

export const createOrderThunk = createAsyncThunk(
  "orders/createOrder",
  async (orderData, { getState, rejectWithValue }) => {

    const randomAmount = Math.floor(Math.random() * 26) + 5; // от 5 до 30
    const newPrice = orderData.price + randomAmount;

 
    const updatedOrderData = { ...orderData, price: newPrice };

    const token = getState().authStore.token; 
    try {
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      const response = await instance.post("/orders", updatedOrderData, config); 
      return response.data;
    } catch (error) {

      if (error.response && error.response.status === 404) {
        Notiflix.Notify.failure("Ошибка: ресурс не найден (404)"); 
        return rejectWithValue("Ошибка: ресурс не найден (404)");
      }

      Notiflix.Notify.failure(error.response?.data || error.message);  
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const fetchOrderById = createAsyncThunk(
  "orders/fetchOrderById",
  async (id, thunkApi) => {
    try {
      const response = await axios.get(`${API_URL}orders/${id}`);
      
      return response.data;
    } catch (err) {
      
      if (err.status === 404) {
        return thunkApi.rejectWithValue("Заявка не найдена");
      }
      return thunkApi.rejectWithValue(err.message);
    }
  }
);


export const extendOrderThunk = createAsyncThunk(
  "orders/extendOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}orders/${orderId}/extend`);
      return response.data;
    } catch (error) {
      
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const deleteOrderThunk = createAsyncThunk(
  "orders/deleteOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}orders/delete-order/${orderId}`);
      return orderId;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
